/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsCreateGipAltReportMutationRequest, AuditReportsCreateGipAltReportMutationResponse, AuditReportsCreateGipAltReport400, AuditReportsCreateGipAltReport401, AuditReportsCreateGipAltReport403, AuditReportsCreateGipAltReport500 } from "../models/AuditReportsCreateGipAltReport";

export function getAuditReportsCreateGipAltReportUrl() {
  const res = { method: 'POST', url: `/audit-reports/v1/reports/gip-alt/report` as const }
  return res
}

/**
 * @summary Create new report
 * {@link /audit-reports/v1/reports/gip-alt/report}
 */
export async function auditReportsCreateGipAltReport(data: AuditReportsCreateGipAltReportMutationRequest, config: Partial<RequestConfig<AuditReportsCreateGipAltReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsCreateGipAltReportMutationResponse, ResponseErrorConfig<AuditReportsCreateGipAltReport400 | AuditReportsCreateGipAltReport401 | AuditReportsCreateGipAltReport403 | AuditReportsCreateGipAltReport500>, AuditReportsCreateGipAltReportMutationRequest>({ method : "POST", url : getAuditReportsCreateGipAltReportUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}